var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 1.83334C5.93992 1.83334 1.83325 5.94001 1.83325 11C1.83325 16.06 5.93992 20.1667 10.9999 20.1667C16.0599 20.1667 20.1666 16.06 20.1666 11C20.1666 5.94001 16.0599 1.83334 10.9999 1.83334ZM11.9166 15.5833H10.0833V10.0833H11.9166V15.5833ZM11.9166 8.25001H10.0833V6.41668H11.9166V8.25001Z",
    fill: "#38495F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info-filled.4f9fe938f740f7c7274ed360c81557b1.svg";
export { ForwardRef as ReactComponent };